import { RentalStatus } from './hooks/useRentalStatus'
import useTranslation from 'hooks/useTranslation'
import React from 'react'

const RentalStatusOption: React.FC<{ status: RentalStatus }> = ({ status }) => {
  const { t } = useTranslation('warehouse')
  return (
    <div className='status__option'>
      <span>
        {status.key === 'availableIn'
          ? `${t('availableIn')} ${status.days === 1 ? `1 ${t('day')}` : `${status.days} ${t('days')}`}`
          : t(status.key)}
      </span>
    </div>
  )
}

export default RentalStatusOption
